var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOralMeds = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.293 5.957a1 1 0 0 1 0-1.414 3.07 3.07 0 0 1 4.343 0 1 1 0 1 1-1.414 1.414 1.07 1.07 0 0 0-1.515 0 1 1 0 0 1-1.414 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.182 14.91a6.5 6.5 0 0 0 9.193 9.192l12.727-12.728a6.5 6.5 0 1 0-9.192-9.192zm1.414 7.778a4.5 4.5 0 0 1 0-6.364l5.657-5.657 6.364 6.364-5.657 5.657a4.5 4.5 0 0 1-6.364 0m13.435-7.07 5.657-5.658a4.5 4.5 0 1 0-6.364-6.364l-5.657 5.657zM17 24a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-5a5 5 0 0 0-4.172 7.757l6.93-6.929A4.98 4.98 0 0 0 24 19m0 10a4.98 4.98 0 0 1-2.757-.828l6.929-6.93A5 5 0 0 1 24 29",
  clipRule: "evenodd"
})));
export default SvgOralMeds;